import React, { useState } from "react";

import { useAuth } from "../../services/authentication/authentication.context";
import { RightNav } from "../../components/main-components/right-nav";
import { AppFooter } from "../../components/main-components/footer";
import { Loader } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/alert";
import { formatUrl } from "../../helpers/parse-url";

import "../../styles/profile.css";
import { ProfileCard } from "../../components/cards/profile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faEdit } from "@fortawesome/free-solid-svg-icons";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";

export const MyProfilePage = () => {

    const { userData, isLoading, accountUpdate, token, deleteMyAccount } = useAuth();

    const [alertObj, setAlertObj] = useState({
        message: null,
        caption: null
    });
    const [imagePrev, setImagePrev] = useState(null);
    const [isAlert, setisAlert] = useState(false);
    const [update, setUpdate] = useState(false);

    const fileBtn = React.useRef();


    React.useEffect(() => {
        console.log({ mydata: userData })
    }, [userData])

    const [profileData, setProfileData] = useState({
        names: '',
        username: '',
        biodata: '',
        phoneNumber: '',
        avatar: '',
        imageFile: null
    });
    
    const [showWarning, setShowWarning] = useState(false);
    const [acceptDelete, setAcceptDelete] = useState(false);
    const [usernm, setUsernm] = useState('')

    const ValidateData = () => {
        const isNull = (v) => v === undefined || v === null || v === "";
        if (isNull(profileData?.names)) {
            setisAlert(true);
            setAlertObj({
                caption: "Error! Invalid data!",
                message: "Names cannot be null",
            })
        }
    }

    return (
        <div>
            <BmsHeader />
            <SkewBox background={"/media/profile-pic.jpg"} title={'My profile'} />
            <div className="notes-page">
                {isLoading && <Loader />}

                {isAlert &&
                    <AppAlert
                        caption={alertObj.caption}
                        message={alertObj.message}
                        accept={"Ok"}
                        acceptAction={alertObj.acceptAction}
                    />
                }

                <div className="main-page">
                    {userData?.superAdmin && (
                        <div className="flx-c-r sp-4">
                            <button
                                className="dash-button"
                                onClick={() => window.location.href = "/admin"}
                            >
                                Go to Dashboard
                            </button>
                        </div>

                    )}
                    <div className="search-caption">
                        <span>My profile</span>
                        <button className="edit-btn"
                            onClick={() => {
                                setUpdate((u) => !u)
                                setProfileData({
                                    names: userData?.names,
                                    username: userData?.username,
                                    biodata: userData?.biodata,
                                    phoneNumber: userData?.phoneNumber
                                })
                            }}
                        >
                            <FontAwesomeIcon
                                icon={update ? faClose : faEdit}
                            />
                        </button>
                    </div>

                    {!update && <ProfileCard />}
                    {update &&
                        <div className="question-form">
                            <div className="image-container">
                                <img
                                    className="profile-iage"
                                    src={
                                        imagePrev ? imagePrev : (
                                            userData?.avatar ?
                                                formatUrl(userData?.avatar) :
                                                "/media/peer.png"
                                        )
                                    }
                                    alt=""
                                    width={100}
                                    height={100}
                                />
                                <button
                                    className="image-upload"
                                    onClick={() => fileBtn.current.click()}
                                >
                                    Add picture
                                </button>
                                <input
                                    type="file"
                                    className="file-button"
                                    onChange={(e) => {
                                        setImagePrev(URL.createObjectURL(e.target.files[0]));
                                        setProfileData((data) => ({ ...data, imageFile: e.target.files[0] }));
                                    }}
                                    ref={fileBtn}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Names</span>
                                <input
                                    type="text"
                                    value={profileData?.names}
                                    className="input"
                                    placeholder="Enter your full names"
                                    onChange={(e) => setProfileData((cred) => (
                                        { ...cred, names: e.target.value }
                                    ))}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Username</span>
                                <input
                                    type="text"
                                    value={profileData?.username}
                                    className="input"
                                    placeholder="Enter your username"
                                    onChange={(e) => setProfileData((cred) => (
                                        { ...cred, username: e.target.value }
                                    ))}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Phone Number</span>
                                <input
                                    type="tel"
                                    value={profileData?.phoneNumber}
                                    className="input"
                                    placeholder="your phone number with area code"
                                    onChange={(e) => setProfileData((cred) => (
                                        { ...cred, phoneNumber: e.target.value }
                                    ))}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">bio</span>
                                <textarea
                                    className="input"
                                    cols={10}
                                    rows={10}
                                    placeholder="say something about yourself"
                                    onChange={(e) => setProfileData((data) => ({ ...data, biodata: e.target.value }))}
                                    value={profileData?.biodata}
                                >

                                </textarea>
                            </div>

                            <button
                                className="form-button"
                                onClick={async (e) => {
                                    e.preventDefault();
                                    ValidateData();
                                    const resp = await accountUpdate(profileData, token);
                                    setAlertObj({
                                        message: resp?.message,
                                        caption: "Success!",
                                        acceptAction: () => window.location.reload()
                                    });
                                    setisAlert(true);
                                }}
                            >
                                Upate personal data
                            </button>
                        </div>}
                    <div className="danger-zone question-form">
                        <div className="danger-signal">Danger Zone</div>
                        <button className="dash-button danger-btn" onClick={() => setShowWarning(true)}>
                            Close Account
                        </button>
                        {showWarning &&
                            <div className="del-zone">
                                <div className="del-message-box">
                                    Closing your account will completely delete your account data and past transactions from our database. You must take note that this action is irreversible, and we will not be held responsible for the lost data and privilleges.
                                </div>
                                <div className="check-zone">
                                    <input
                                        type="checkbox"
                                        className="chk"
                                        checked={acceptDelete}
                                        onChange={() => setAcceptDelete(!acceptDelete)}
                                    />
                                    <span className="accept-txt">I have read and accepted terms</span>
                                </div>
                                {acceptDelete && (
                                    <div className="delete-box">
                                        <div className="del-input-box">
                                            <article className="del-init">
                                                <span>Type your username</span>
                                                <span className="u-nm">{userData?.username}</span>
                                                <span>to confirm.</span>
                                            </article>
                                            <input
                                                type="text"
                                                className="del-input"
                                                value={usernm}
                                                onChange={(e) => setUsernm(e.target.value)}
                                            />
                                        </div>
                                        {usernm === userData?.username &&
                                            <div className="del-button-box">
                                                <button
                                                    className="del-button"
                                                    onClick={async () => {
                                                        const resp = await deleteMyAccount(token, usernm);
                                                        console.log(resp);
                                                        if (resp?.error) {
                                                            setisAlert(true);
                                                            setAlertObj({
                                                                caption: "Delete Account!",
                                                                message: resp?.error,
                                                                acceptAction: () => setisAlert(false)
                                                            });
                                                            return;
                                                        }
                                                        setisAlert(true);
                                                        setAlertObj({
                                                            caption: "Delete Account!",
                                                            message: resp?.message,
                                                            acceptAction: () => window.location.reload()
                                                        })
                                                    }}
                                                >
                                                    Delete my account
                                                </button>
                                            </div>
                                        }
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </div>
                <RightNav />
            </div>
            <AppFooter />
        </div>
    );
}